import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataBox } from '../../common/components/data-box.component';
import { SendMessageInput } from './send-message-input.component';
import { TargetPickerForm } from '../../feed/components/target-picker-form.container';
import { FlatButton, RaisedButton } from 'material-ui';
import { push } from 'react-router-redux';
import { store } from '../../store';
import { Loading } from '../../common/components/loading.component';
import { uploadImageAsset } from '../../core/images/upload-asset';

export class HelpdeskNewChatView extends Component {
  static propTypes = {
    sendMessage: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      groups: ['all'],
      review: false,
      content: '',
      isLoading: false,
      messageType: 'TEXT',
    };
  }

  reviewMessage(messageType, content) {
    if (this.state.groups.length === 0) {
      alert('Please pick at least one recipient');

      return;
    }

    this.setState({
      review: true,
      content,
      messageType,
    });
  }

  updateGroups(groups) {
    this.setState({
      groups: this.sanitizeGroups(groups),
    });
  }

  sanitizeGroups(groups) {
    return (groups || []).filter(g => g !== 'users' && g !== 'courses');
  }

  getTextCount() {
    if (this.state.groups.includes('all')) {
      return 'all participants';
    }

    const totalUsers = this.state.groups.filter(g => g.startsWith('user_')).length;
    const totalCourses = this.state.groups.filter(g => g.startsWith('course_')).length;
    const result = [];

    if (totalUsers > 0) {
      result.push(`${totalUsers} user(s)`);
    }

    if (totalCourses > 0) {
      result.push(`${totalCourses} course(s)`);
    }

    return result.join(' and ');
  }

  async sendMessage() {
    this.setState({ isLoading: true });

    try {
      let content = this.state.content;

      if (this.state.messageType === 'IMAGE') {
        if (content instanceof File) {
          content = await uploadImageAsset(content, 'helpdesk-chat');
        } else if (content && String(content).startsWith('data:image/')) {
          content = await uploadImageAsset(content, 'helpdesk-chat');
        }
      }

      const groups = this.sanitizeGroups(this.state.groups);
      const result = await this.props.sendMessage(
        this.state.messageType,
        content,
        groups,
      );
      const count = result?.data?.sendHelpdeskBulkMessage;

      if (count === null || count === undefined) {
        alert('Failed to send message. Check helpdesk user configuration.');
        this.setState({ isLoading: false });
        return;
      }

      if (count === 0) {
        alert('No recipients matched your selection.');
        this.setState({ isLoading: false, review: false });
        return;
      }

      store.dispatch(push('/admin/helpdesk?reload=true'));
    } catch (error) {
      console.error(error);
      alert('Failed to send message. Please try again.');
      this.setState({ isLoading: false });
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <DataBox title="Compose Help Center Message">
          {
            this.state.isLoading ? (
              <Loading />
            ) : (
              this.state.review ? (
                <div style={styles.reviewParent}>
                  <h2>Are you sure?</h2>
                  <h3>Send message to {this.getTextCount()}?</h3>
                  {
                    this.state.messageType === 'TEXT' ? (
                      <blockquote>
                        {this.state.content}
                      </blockquote>
                    ) : (
                      <div>
                        <img alt={''} src={this.state.content} style={{ maxWidth: 400 }} />
                      </div>
                    )
                  }
                  <div>
                    <RaisedButton
                      primary={true}
                      onClick={() => this.sendMessage()}
                      label="Yes, send this message" />
                    <FlatButton
                      style={{ marginLeft: 10 }}
                      onClick={() => {
                        this.setState({ review: false });
                      }}
                      label="Cancel" />
                  </div>
                </div>
              ) : (
                <div>
                  <TargetPickerForm
                    groups={this.state.groups}
                    disableAllUsers={false}
                    initialOpenPickers={['users']}
                    hideButtons={true}
                    onChange={groups => this.updateGroups(groups)} />
                  <SendMessageInput
                    content={this.state.content}
                    skipClearOnSend={true}
                    disablePicture={false}
                    disabled={this.state.groups.length === 0}
                    onSendMessage={this.reviewMessage.bind(this)} />
                </div>
              )
            )
          }
        </DataBox>
      </div>
    );
  }
}

const styles = {
  container: {
    padding: '1%',
  },
  reviewParent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
};
